export default {
  methods: {
    scrollTo (element, options = {}) {
      if (!element) {
        return
      }

      const nav = document.querySelector('.w-full.sticky-top.header-nav__bg').offsetHeight
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const top = element.getBoundingClientRect().top

      if (options.checkIfBelow && window.scrollY < top) {
        return
      }

      this._scrollAction(top + scrollTop - nav)
    },
    scrollToTop () {
      this._scrollAction(0)
    },
    _scrollAction (top) {
      try {
        window.scrollTo({ top, behavior: 'smooth' })
      } catch {
        window.scrollTo(0, top)
      }
    },
  },
}
